import { render, staticRenderFns } from "./SequenceEvaluations.vue?vue&type=template&id=064197e2&scoped=true"
import script from "./SequenceEvaluations.vue?vue&type=script&lang=js"
export * from "./SequenceEvaluations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064197e2",
  null
  
)

export default component.exports